import { createFileRoute } from "@tanstack/react-router";
import { InfoLayout } from "@/components/laneguide/InfoLayout";

export const Route = createFileRoute("/villkor")({
  head: () => ({
    meta: [
      { title: "Allmänna villkor för jämförelsetjänsten | Svensk Låneguide" },
      { name: "description", content: "Allmänna villkor för användning av Svensk Låneguide – tjänstens omfattning, ansvar, ersättningsmodell och dina skyldigheter som användare." },
      { property: "og:title", content: "Allmänna villkor | Svensk Låneguide" },
      { property: "og:description", content: "Villkoren för att använda Svensk Låneguides kostnadsfria jämförelsetjänst." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <InfoLayout title="Allmänna villkor">
      <p>
        Nedan följer de allmänna villkoren för användning av svensklaneguide.se. Genom att använda webbplatsen accepterar du villkoren. Läs dem gärna noggrant innan du använder våra jämförelser, kalkylatorer eller vårt lånetest.
      </p>

      <h2>Om tjänsten</h2>
      <p>
        Svensk Låneguide är en kostnadsfri och oberoende jämförelsetjänst som hjälper dig att jämföra olika typer av lån, krediter och långivare. Eftersom tjänsten är helt kostnadsfri för dig som användare kan du aldrig krävas på någon form av avgift eller ersättning. Vi arbetar fristående och styrs inte av enskilda långivare, och vi är inte involverade i de listade bolagens verksamhet.
      </p>
      <p>
        Du kan inte ansöka om lån direkt hos oss. Vi visar information och länkar vidare till respektive långivare, där själva ansökan sker på långivarens egna villkor.
      </p>

      <h2>Vem får använda tjänsten</h2>
      <p>
        Tjänsten riktar sig till privatpersoner som är minst 18 år och bosatta i Sverige. Enligt lag krävs att du är över 18 år för att låna pengar, och många kreditbolag tillämpar en högre åldersgräns. Du ansvarar själv för att den information du lämnar i vårt lånetest är korrekt.
      </p>

      <h2>Information och priser</h2>
      <p>
        Vi lägger stor vikt vid att räntor, belopp, löptider och avgifter ska vara korrekta och uppdaterade. Villkor kan dock ändras av långivaren utan förvarning, och den ränta du personligen erbjuds sätts alltid individuellt efter en kreditbedömning. Uppgifterna på sajten är därför alltid vägledande – de faktiska villkoren framgår av det avtal du får från långivaren.
      </p>
      <p>
        Räkneexempel som visas är typexempel och ska inte tolkas som ett erbjudande. Effektiv ränta inkluderar ränta och kända avgifter, och är det mått du bör jämföra långivare med.
      </p>

      <h2>Så tjänar vi pengar</h2>
      <p>
        Vi får ersättning från vissa långivare när en besökare klickar sig vidare eller genomför en ansökan. Ersättningen påverkar aldrig de villkor du erbjuds och kostar dig ingenting. Vår redaktionella bedömning och rangordning bygger på villkor, transparens, kundnöjdhet och tillgänglighet – inte på ersättningsnivå.
      </p>

      <h2>Vårt ansvar</h2>
      <p>
        Svensk Låneguide står helt utanför avtalet mellan långivare och låntagare och tar därför inget ansvar för skador, skulder eller konflikter som kan uppstå mellan parterna. Vi ansvarar inte heller för innehållet på externa webbplatser som vi länkar till. Vi ansvarar endast för det innehåll som publiceras på svensklaneguide.se, och vi lämnar ingen finansiell rådgivning.
      </p>
      <p>
        Vi strävar efter att sajten alltid ska vara tillgänglig men kan inte garantera drift utan avbrott. Vid underhåll, tekniska fel eller händelser utanför vår kontroll kan tjänsten vara otillgänglig.
      </p>

      <h2>Ditt ansvar som låntagare</h2>
      <p>
        Du ansvarar själv för dina lånebeslut. Innan du tecknar ett lån bör du gå igenom hela avtalet, kontrollera den effektiva räntan, den totala återbetalningen och att månadskostnaden ryms i din budget. Du har enligt konsumentkreditlagen 14 dagars ångerrätt vid nya krediter och rätt att lösa lånet i förtid.
      </p>

      <h2>Immateriella rättigheter</h2>
      <p>
        Allt innehåll på svensklaneguide.se – texter, grafik, struktur och sammanställningar – tillhör AdTract Sweden eller våra samarbetspartners och skyddas av upphovsrätt. Innehållet får inte kopieras eller återpubliceras i kommersiellt syfte utan skriftligt medgivande. Kortare citat är tillåtna om tydlig källhänvisning med länk anges.
      </p>

      <h2>Personuppgifter och cookies</h2>
      <p>
        Hur vi behandlar personuppgifter beskrivs i vår integritetspolicy, och hur vi använder cookies beskrivs på vår cookiesida. Kontakta det företag där du gjort en ansökan om du har frågor om ditt lån eller de uppgifter du lämnat där.
      </p>

      <h2>Klagomål och synpunkter</h2>
      <p>
        Har du synpunkter på vårt innehåll eller upptäckt en felaktig uppgift är vi tacksamma om du hör av dig. Vi granskar alla inkomna synpunkter och rättar felaktigheter så snart som möjligt. Rör klagomålet ett lån du tecknat ska du i första hand vända dig till långivarens klagomålsansvarige, och därefter eventuellt till Allmänna reklamationsnämnden.
      </p>

      <h2>Ändringar av villkoren</h2>
      <p>
        Svensk Låneguide kan komma att ändra dessa villkor. Vid ändring uppdateras denna sida, och den senaste versionen gäller från publiceringsdatumet.
      </p>

      <h2>Tillämplig lag</h2>
      <p>
        Svensk lag tillämpas på dessa villkor och på användningen av webbplatsen. Eventuella tvister prövas av svensk allmän domstol.
      </p>

      <h2>Kontakt</h2>
      <p>
        AdTract Sweden<br />Rexegatan 40, Kungälv, Sverige<br />Org.nr 040127-8858<br />E-post: svensklaneguide@outlook.com<br />Telefon: 0721-63 23 36
      </p>
    </InfoLayout>
  ),
});
